// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__rPi9c","info":"Note_info__3J5Xx","note":"Note_note__1CLo7","actions":"Note_actions__1hvxj"};